import React, { useMemo, useState } from 'react'

import { faMap } from '@fortawesome/pro-solid-svg-icons'
import { Box, Divider, FormControl, MenuItem, Paper, Select, Toolbar, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import TableViewToggle from '../TableViewToggle'
import List from './List'
import Map from './Map'
import TableView from './TableView'
import useStateDetails from './useStateDetails'
import useStateSummaries from './useStateSummaries'

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: 0,
  },
  toolbar: {
    padding: theme.spacing(2),
    flexWrap: 'wrap',
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
    },
  },
  title: {
    flex: '1 1 100%',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginBottom: 0,
    },
  },
  formControl: {
    minWidth: 200,
  },
  responsiveContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    alignItems: 'center',

    '& > *:not(.MuiSnackbar-root)': {
      width: '50%',
      flexGrow: 1,
      boxShadow: `1px 0px 0px 0px ${theme.palette.grey[200]}`,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
}))

const ProspectiveStudentsByLocationCard = () => {
  const styles = useStyles()
  const [selectedStateId, setSelectedStateId] = useState('all_states')
  const [tableView, setTableView] = useState(false)
  const {
    error: errorStateSummaries,
    loading: loadingStateSummaries,
    stateSummaries,
  } = useStateSummaries(selectedStateId)
  const { error: errorStateDetails, loading: loadingStateDetails, stateDetails } = useStateDetails(selectedStateId)
  const states = useMemo(
    () => [
      { label: 'All States', value: 'all_states' },
      ...((stateSummaries && stateSummaries.map((summary) => ({ label: summary.state, value: summary.state }))) || []),
    ],
    [stateSummaries],
  )

  const handleStateSelected = (value) => {
    if (states.find((state) => state.value === value)) setSelectedStateId(value)
  }

  return (
    <Box mt={1}>
      <Paper
        elevation={0}
        className={styles.paper}
      >
        <Toolbar className={styles.toolbar}>
          <Typography className={styles.title}>Students by Location</Typography>
          <FormControl
            className={styles.formControl}
            variant="outlined"
            size="small"
          >
            <Select
              id="prospective-students-by-location-card-select"
              value={selectedStateId}
              onChange={(e) => setSelectedStateId(e.target.value)}
              disabled={loadingStateSummaries}
              aria-label="state options"
            >
              {states.map((state) => (
                <MenuItem
                  key={state.value}
                  value={state.value}
                >
                  {' '}
                  {state.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box m={1} />
          <TableViewToggle
            tableView={tableView}
            setTableView={setTableView}
            viewIcon={faMap}
            viewAriaLabel="view map"
          />
        </Toolbar>
        <Divider light />
        <Box className={styles.responsiveContainer}>
          {tableView ? (
            <TableView data={stateSummaries || []} />
          ) : (
            <Map
              loading={loadingStateSummaries}
              stateStats={stateSummaries || []}
              onSelectState={handleStateSelected}
            />
          )}
          <List
            error={errorStateSummaries || errorStateDetails}
            loading={loadingStateDetails}
            schools={stateDetails || []}
          />
        </Box>
      </Paper>
    </Box>
  )
}

export default ProspectiveStudentsByLocationCard
